/**
 * @deprecated Use TRADE_ITEM_SORT_OPTIONS from "modules/common/constants/tradeItemSortOptions" instead.
 * This re-export is kept for backward compatibility.
 */
export {
  TRADE_ITEM_SORT_OPTIONS as LGS_TRADE_ITEMS_SORT_OPTIONS,
  TRADE_ITEM_SORT_OPTIONS_MOBILE as LGS_TRADE_ITEMS_SORT_OPTIONS_MOBILE,
} from "modules/common/constants/tradeItemSortOptions";
